import Vue from 'vue';
export default Vue.extend({
    computed: {
        selectedFinish() {
            return this.$store.state.system_configuration.selections.structureFinish;
        },
    },
});
